import styled from "styled-components";
import { DINGY_GRAY, NEAR_BLACK, NEAR_WHITE } from "../../../config";

export const ModalContainer = styled.div`
  position: absolute;
  right: 32px;
  top: calc(100% + 4px);
  display: flex;
  flex-direction: column;
  padding: 12px;
  color: ${NEAR_WHITE};
  font-size: 14px;
  background: ${NEAR_BLACK};
  border: 1px solid ${DINGY_GRAY};
  border-radius: 4px;
  width: 300px;
  max-height: 300px;
  transform-origin: top right;
  animation: openMenu 0.1s ease-out;
  z-index: 1;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  font-weight: bold;
  cursor: default;

  div:first-child {
    font-size: 18px;
  }

  div:nth-child(2) {
    font-size: 12px;
    cursor: pointer;
    outline: none;
  }
`;

export const Content = styled.div`
  overflow: auto;
  max-height: 250px;
`;

export const SectionTitle = styled.div<{ isOpen: boolean }>`
  display: flex;
  align-items: center;
  font-weight: bold;
  color: ${NEAR_WHITE};
  height: 38px;
  margin-left: 2px;
  cursor: pointer;

  svg {
    margin-right: 12px;
    font-size: 16px;
    transition: 0.2s ease;
    transform: ${(props) => (props.isOpen ? "rotateZ(90deg)" : "rotateZ(0deg)")};
  }
`;

export const CheckboxWrapper = styled.div`
  & > div {
    margin-left: 20px;
    padding-bottom: 8px;
  }
`;
